/* Octagon - miniatury w galerii na KARCIE PRODUKTU.

   ZAKRES: nasluchy podpiete do konkretnego <media-gallery>, NIGDY do
   document ani body - globalne nasluchy lapia okno powiekszenia i psuja
   je (okno ma wlasny plik: octagon-zoom-swipe.js).

   ROBI DWIE RZECZY:

   1) KLIKNIECIE MINIATURY
      octagon-variant-media.js ukrywa zdjecia innych kolorow, a motyw liczy
      numery po PELNEJ liscie - przy kolorze 2 i 3 numery sie rozjezdzaly.
      Przeliczamy numer widocznej miniatury na numer widocznego slajdu
      i wywolujemy slideshow.select() (wlasny mechanizm motywu,
      z assets/media-gallery.js).

   2) ZAZNACZENIE PODCZAS PRZEWIJANIA
      Motyw odswieza zaznaczenie dopiero po zatrzymaniu przewijania, wiec
      poprzednia miniatura "wisi" jeszcze chwile obok nowej. Przyspieszamy
      to w kazdej klatce (rAF), ale ustawiamy WLASNY ZNACZNIK MOTYWU
      (aria-selected), a nie wlasny obrys - dzieki temu obrys jest zawsze
      tylko jeden.
      NIE dodawac wlasnej klasy z obrysem - probowane, dawalo dwa obrysy
      naraz i wygladalo jak zacinanie. */
(() => {
  const GALLERY = 'media-gallery';
  const THUMB = '.slideshow-controls__thumbnail';
  const SLIDE = 'slideshow-slide, .product-media-container';
  const ZOOM = '.dialog-zoomed-gallery__dialog';

  const isVisible = (el) =>
    el && !el.hidden && el.style.display !== 'none' && el.getClientRects().length > 0;

  const visThumbs = (g) => Array.from(g.querySelectorAll(THUMB)).filter(isVisible);

  function allSlides(g) {
    const all = Array.from(g.querySelectorAll(SLIDE)).filter((el) => !el.closest(ZOOM));
    return all.filter((el) => !all.some((o) => o !== el && el.contains(o)));
  }

  const visSlides = (g) => allSlides(g).filter(isVisible);

  function scrollerOf(el) {
    let p = el.parentElement;
    while (p && p !== document.body) {
      const s = getComputedStyle(p);
      const y = /(auto|scroll)/.test(s.overflowY) && p.scrollHeight > p.clientHeight + 2;
      const x = /(auto|scroll)/.test(s.overflowX) && p.scrollWidth > p.clientWidth + 2;
      if (y || x) return p;
      p = p.parentElement;
    }
    return null;
  }

  function goToSlide(gallery, visibleIndex) {
    const target = visSlides(gallery)[visibleIndex];
    if (!target) return;

    const realIndex = allSlides(gallery).indexOf(target);
    const slideshow = gallery.slideshow;

    if (slideshow && typeof slideshow.select === 'function' && realIndex >= 0) {
      try {
        slideshow.select(realIndex);
        return;
      } catch (err) {
        /* zapasowo przewijamy recznie */
      }
    }

    const box = scrollerOf(target);
    if (box) {
      const t = target.getBoundingClientRect();
      const b = box.getBoundingClientRect();
      box.scrollTo({
        top: box.scrollTop + (t.top - b.top),
        left: box.scrollLeft + (t.left - b.left),
        behavior: 'smooth',
      });
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  /* Ktory slajd jest teraz najblizej srodka galerii */
  function centeredIndex(gallery) {
    const slides = visSlides(gallery);
    if (!slides.length) return -1;

    const g = gallery.getBoundingClientRect();
    const cx = g.left + g.width / 2;

    let best = 0;
    let bestDist = Infinity;

    slides.forEach((s, i) => {
      const r = s.getBoundingClientRect();
      const d = Math.abs(r.left + r.width / 2 - cx);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    });

    return best;
  }

  /* Ustawiamy ZNACZNIK MOTYWU, nie wlasny obrys */
  function markThumb(gallery, index) {
    const thumbs = visThumbs(gallery);
    thumbs.forEach((t, i) => {
      const el = t.tagName === 'BUTTON' ? t : t.querySelector('button') || t;
      const want = String(i === index);
      if (el.getAttribute('aria-selected') !== want) {
        el.setAttribute('aria-selected', want);
      }
    });
  }

  function attach(gallery) {
    if (gallery.dataset.octThumbs === '1') return;
    gallery.dataset.octThumbs = '1';

    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest ? e.target.closest(THUMB) : null;
      if (!thumb || thumb.closest(ZOOM)) return;

      const index = visThumbs(gallery).indexOf(thumb);
      if (index < 0) return;

      setTimeout(() => goToSlide(gallery, index), 30);
    });

    /* Natychmiastowe zaznaczenie podczas przewijania - bez opoznienia */
    let queued = false;
    let last = -1;

    gallery.addEventListener(
      'scroll',
      () => {
        if (queued) return;
        queued = true;

        requestAnimationFrame(() => {
          queued = false;
          const i = centeredIndex(gallery);
          if (i >= 0 && i !== last) {
            last = i;
            markThumb(gallery, i);
          }
        });
      },
      { passive: true, capture: true }
    );
  }

  function boot() {
    document.querySelectorAll(GALLERY).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(boot, 300));
  } else {
    setTimeout(boot, 300);
  }

  /* Galeria jest podmieniana przy zmianie wariantu - dopinamy nowe */
  setInterval(boot, 1500);
})();
